export const NEW_ROLES_ERROR = `Erro ao tentar criar grupo de permissão`;
export const NEW_ROLES_SUCCESS = `Grupo criado com sucesso.`;
export const ROLES_UPDATE_SUCCESS = `Grupo atualizado com sucesso.`;
export const ROLES_UPDATE_ERROR = `Erro ao tentar atualizar grupo.`;
export const DELETE_ROLES_SUCCESS = `Grupo deletado com sucesso.`;
export const DELETE_ROLES_ERROR = `Erro ao tentar deletar grupo.`;
